import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-flower-line text-xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-900">
                樱花漫画网
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              全集漫画大全，漫画全集免费完整版下拉式在线阅读。好看的韩漫日漫国漫全本漫画推荐，一次看个够。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-800 mb-4 text-sm">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/all" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">漫画大全</Link>
              <Link to="/category/hanman" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">韩漫专区</Link>
              <Link to="/category/riman" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">日漫专区</Link>
              <Link to="/category/guoman" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">国漫专区</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-800 mb-4 text-sm">
              热门推荐
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/article/1" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">我独自升级</Link>
              <Link to="/article/4" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">间谍过家家</Link>
              <Link to="/article/6" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">全职高手</Link>
              <Link to="/article/7" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">鬼灭之刃</Link>
              <Link to="/article/5" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">一人之下</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-800 mb-4 text-sm">
              关于我们
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">品牌介绍</Link>
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">联系我们</Link>
              <p className="text-sm text-foreground-400 mt-2">
                客服邮箱：service@yinghuacomic.com
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 樱花漫画网 yinghuacomic.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}